import { VatDeclarationStatus } from '../enums/vatDeclarationStatus'

export const vatDeclarationStatusToTitleKey: Record<VatDeclarationStatus, string> = {
  [VatDeclarationStatus.Draft]: 'vat_declarations.table.category.draft',
  [VatDeclarationStatus.OverduePayment]: 'vat_declarations.table.category.overdue',
  [VatDeclarationStatus.OverdueSubmission]: 'vat_declarations.table.category.overdue',
  [VatDeclarationStatus.Paid]: 'vat_declarations.table.category.paid',
  [VatDeclarationStatus.Pending]: 'vat_declarations.table.category.pending',
  [VatDeclarationStatus.ReadyToPay]: 'vat_declarations.table.category.ready_to_pay',
  [VatDeclarationStatus.ReadyToSubmit]: 'vat_declarations.table.category.ready_to_submit',
  [VatDeclarationStatus.SubmissionFailed]: 'vat_declarations.table.category.submission_failed',
}
